"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customToolLinksApi = exports.deleteCustomToolLinkFromTest = exports.addCustomToolLinkToTest = exports.getCustomToolLinksForTest = exports.deleteCustomToolLink = exports.updateCustomToolLink = exports.addCustomToolLink = exports.getCustomToolLinks = void 0;
// Account Tool Links
const getCustomToolLinks = (caller) => ({ accountId, queryParams }) => {
    return caller(`/api/core/accounts/${accountId}/customtoollinks`).get(queryParams);
};
exports.getCustomToolLinks = getCustomToolLinks;
const addCustomToolLink = (caller) => ({ accountId, payload }) => {
    return caller(`/api/core/accounts/${accountId}/customtoollinks`).post(payload, { withResponse: true });
};
exports.addCustomToolLink = addCustomToolLink;
const updateCustomToolLink = (caller) => ({ accountId, toolLinkId, payload }) => {
    return caller(`/api/core/accounts/${accountId}/customtoollinks/${toolLinkId}`).patch(payload);
};
exports.updateCustomToolLink = updateCustomToolLink;
const deleteCustomToolLink = (caller) => ({ accountId, toolLinkId }) => {
    return caller(`/api/core/accounts/${accountId}/customtoollinks/${toolLinkId}`).delete();
};
exports.deleteCustomToolLink = deleteCustomToolLink;
// Test Tool Links
const getCustomToolLinksForTest = (caller) => ({ accountId, testId, queryParams }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/customtoollinks`).get(queryParams);
};
exports.getCustomToolLinksForTest = getCustomToolLinksForTest;
const addCustomToolLinkToTest = (caller) => ({ accountId, testId, toolLinkId }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/customtoollinks/${toolLinkId}`).post();
};
exports.addCustomToolLinkToTest = addCustomToolLinkToTest;
const deleteCustomToolLinkFromTest = (caller) => ({ accountId, testId, toolLinkId }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/customtoollinks/${toolLinkId}`).delete();
};
exports.deleteCustomToolLinkFromTest = deleteCustomToolLinkFromTest;
const customToolLinksApi = (caller) => ({
    getCustomToolLinks: (0, exports.getCustomToolLinks)(caller),
    addCustomToolLink: (0, exports.addCustomToolLink)(caller),
    updateCustomToolLink: (0, exports.updateCustomToolLink)(caller),
    deleteCustomToolLink: (0, exports.deleteCustomToolLink)(caller),
    getCustomToolLinksForTest: (0, exports.getCustomToolLinksForTest)(caller),
    addCustomToolLinkToTest: (0, exports.addCustomToolLinkToTest)(caller),
    deleteCustomToolLinkFromTest: (0, exports.deleteCustomToolLinkFromTest)(caller),
});
exports.customToolLinksApi = customToolLinksApi;
//# sourceMappingURL=api.js.map